import { render, staticRenderFns } from "./bachelorList.vue?vue&type=template&id=7be71cd6&scoped=true"
import script from "./bachelorList.vue?vue&type=script&lang=js"
export * from "./bachelorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be71cd6",
  null
  
)

export default component.exports